// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {canGetProductCustomer} from '../../../shared/services/privacy';
import {getDetails} from '../../shared/repositories';
import {readExternalNotes} from './external-notes';
import {readLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {resetCustomerDetails} from './reset-customer-details';
import {updateAmountOfUseHistory} from './amount-of-use-history';
import {updateClaims} from './claims';
import {updateComponentToAdd} from './component-to-add';
import {updateComponents} from './components';
import {updateCustomer} from './customer';
import {updateImplements} from './implements';
import {updateIncentivePrograms} from './incentive-programs';
import {updateMaintenancePlans} from './maintenance-plan';
import {updateOptionCodes} from './option-codes';
import {updateOptionToAdd} from './option-to-add';
import {updatePIP} from './pip';
import {updateRegistrationHistory} from './registration-history';
import {updateWarranties} from './warranties';

export const resetProductDetails = () =>

    async dispatch => {

        dispatch({
            type: actions.RESET_PRODUCT_DETAILS_STATE
        });

    };

/* eslint-disable complexity */

export const updateProductDetails = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getDetails(pin);

            dispatch({
                payload,
                property: 'product',
                type: actions.UPDATE_PRODUCT_DETAILS_PRODUCT_SUCCESS
            });

            if (canGetProductCustomer(payload)) {

                updateCustomer(payload.customerSummary.id, payload.customerPrivate)(dispatch);

            } else {

                dispatch(resetCustomerDetails());

            }

            if (payload.otherUnitRequired === 'N') {

                updateAmountOfUseHistory(payload.pin)(dispatch);
                updateClaims(payload.pin)(dispatch);
                updateComponents(payload.pin)(dispatch);
                updateImplements(payload.pin)(dispatch);
                updateIncentivePrograms(payload.pin, payload.dealer.account)(dispatch);
                updateMaintenancePlans(payload.pin)(dispatch);
                updateOptionCodes(payload.pin)(dispatch);
                updatePIP(payload.pin)(dispatch);
                updateRegistrationHistory(payload.pin)(dispatch);
                updateWarranties(payload.pin)(dispatch);
                readExternalNotes(payload.pin)(dispatch);
                updateComponentToAdd('pin', payload.pin)(dispatch);
                updateOptionToAdd('pin', payload.pin)(dispatch);
                readLatestPerUnitMeasurements(payload.pin)(dispatch);

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */




// WEBPACK FOOTER //
// ./src/product/details/action-creators/product-details.js